import React, { useState, useEffect } from 'react';
import moment from "moment";
import PiiObfuscator from 'src/components/pii-obfuscator';

const ExpiredOpenBanking = ({ data, loading }) => {
  const [showMore, setShowMore] = useState(false);
  const [limitedItems, setLimitedItems] = useState([]);

  useEffect(() => {
    if (loading || !data?.stats?.open_banking?.items || data?.stats?.open_banking?.items.length === 0) {
      return;
    }

    if (showMore === true) {
      setLimitedItems(data?.stats?.open_banking?.items);
    } else {
      setLimitedItems(data?.stats?.open_banking?.items.slice(0, 5));
    }
  }, [showMore, data]);


  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  if (limitedItems.length === 0 || loading) {
    return <React.Fragment />;
  }

  return (
    <div className="col-span-6 mt-2" id="expiredopenbanking">
      <div className="flex flex-col rounded-md border border-slate-200 animate-in fade-in-50 bg-gray-50">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title w-100">
              <div className='float-right inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-sm text-xs font-medium bg-purple-100 text-purple-800'>
                showing {limitedItems.length} of {data?.stats?.open_banking?.items.length}
              </div>
              <h2 className="text-xl font-normal text-purple-900">
                Expired <span className="font-bold">Open Banking Connections</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="relative pt-14 lg:pt-0">
          <div className="col-span-6 rounded-md animate-in fade-in-50">
            <div className="nk-block">
              <div className="card">
                <div className="card-inner-group">
                  <div className="card-inner p-0">
                    <table className="table table-tranx">
                      <thead>
                        <tr className="tb-tnx-head text-left">
                          <th className="text-left border-r border-r">
                            <span>Organisation</span>
                          </th>
                          <th className="text-center">
                            <span>IBAN</span>
                          </th>
                          <th className="text-center border-l">
                            <span>Last Sync</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {limitedItems.map((item, key) => (
                          <tr className="tb-tnx-item cursor-pointer hover:bg-gray-50" key={key}>
                            <td className="text-left border-r font-bold">
                              <PiiObfuscator type="company">{item.organisation_name}</PiiObfuscator> ({item.organisation_id})
                            </td>
                            <td className="text-center">
                              <PiiObfuscator type="iban">{item.iban}</PiiObfuscator>
                              </td>
                            <td className="text-center border-l">
                              {item.last_sync ? moment(item.last_sync).format('Do MMMM YYYY @ hh:mm') : '-'}
                            </td>
                          </tr>
                        ))}
                        {showMore === false && data?.stats?.open_banking?.items.length > 5 && (
                          <tr className="tb-tnx-item cursor-pointer hover:bg-gray-50" onClick={handleShowMore}>
                            <td className="text-center border-r font-bold" colSpan={3}>
                              <span className="text-purple-900 cursor-pointer">
                                Show More
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <span />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpiredOpenBanking;